/* Game Modes hub: two-axis filter and the "which game is mine" quiz. Reads everything from the cards. */
(function () {
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function clear(n) { while (n.firstChild) n.removeChild(n.firstChild); }
  function has(list, v) { return (' ' + list + ' ').indexOf(' ' + v + ' ') > -1; }

  var cards = [];
  function readCards() {
    cards = all('[data-hm-card]').map(function (c) {
      return { el: c, name: c.getAttribute('data-name'), summary: c.getAttribute('data-summary'), href: c.getAttribute('href'),
        min: +c.getAttribute('data-min'), max: +c.getAttribute('data-max'), games: c.getAttribute('data-games') || '', cats: c.getAttribute('data-cats') || '' };
    });
  }

  /* ---------- Filters: "played on" x "kind of game" ---------- */
  var HASH = { 'shot-ladder': ['game', 'xplr'], xplr: ['game', 'xplr'], quad: ['game', 'quad'], core: ['game', 'core'],
    standard: ['cat', 'standard'], phone: ['cat', 'phone'], dice: ['cat', 'dice'], cards: ['cat', 'cards'], adult: ['cat', 'adult'], groups: ['cat', 'group'], teams: ['cat', 'teams'] };
  function initFilters() {
    var box = document.querySelector('[data-hm-filters]'); if (!box) return;
    var state = { game: 'any', cat: 'any' };
    var gBtns = all('[data-hm-game]', box), cBtns = all('[data-hm-cat]', box);
    var count = box.querySelector('[data-hm-count]'), none = document.querySelector('[data-hm-none]');
    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var ok = (state.game === 'any' || has(c.games, state.game)) && (state.cat === 'any' || has(c.cats, state.cat));
        c.el.hidden = !ok; if (ok) n++;
      });
      all('[data-hm-group]').forEach(function (g) { g.hidden = !g.querySelector('[data-hm-card]:not([hidden])'); });
      gBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hm-game') === state.game)); });
      cBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hm-cat') === state.cat)); });
      if (none) none.hidden = n > 0;
      if (count) count.textContent = (state.game === 'any' && state.cat === 'any') ? 'Showing all ' + n + '.' : 'Showing ' + n + ' of ' + cards.length + '.';
    }
    gBtns.forEach(function (b) { b.addEventListener('click', function () { state.game = b.getAttribute('data-hm-game'); apply(); }); });
    cBtns.forEach(function (b) { b.addEventListener('click', function () { state.cat = b.getAttribute('data-hm-cat'); apply(); }); });
    var h = HASH[(location.hash || '').replace('#', '')];
    if (h) { state[h[0]] = h[1]; apply(); var a = document.getElementById('hm-all'); if (a) a.scrollIntoView(); } else apply();
  }

  /* ---------- Quiz ---------- */
  var QS = [
    { key: 'players', q: "Who's playing?", opts: [
      { v: [1, 1], t: 'Just me' }, { v: [2, 2], t: 'Two of us' }, { v: [3, 4], t: 'Three or four' }, { v: [5, 99], t: 'Five or more' }] },
    { key: 'game', q: 'What have you got?', opts: [
      { v: 'xplr', t: 'HOOKS! XPLR', s: 'The one with the Shot Ladder' }, { v: 'quad', t: 'HOOKS! QUAD', s: 'Four arms, one grid' },
      { v: 'core', t: 'HOOKS! CORE', s: 'The one that stays out' }, { v: 'any', t: "Don't have one yet", s: 'Show me everything' }] },
    { key: 'mood', q: 'What are you in the mood for?', opts: [
      { v: ['standard'], t: 'A straight-up match', s: 'Skill decides it' }, { v: ['phone'], t: 'Something on my phone', s: 'Bombs, ships, bad cans' },
      { v: ['dice', 'cards'], t: 'A bit of luck', s: 'Dice or cards' }, { v: ['adult'], t: 'Raise the stakes', s: 'Adult versions' },
      { v: ['group', 'teams'], t: 'Get everyone in', s: 'Teams and big groups' }] }
  ];
  var MOOD_WHY = { standard: 'a straight-up match', phone: 'runs on your phone', dice: 'uses dice', cards: 'uses cards', adult: 'has an Adult version', group: 'built for a crowd', teams: 'played in teams' };
  function initQuiz() {
    var body = document.querySelector('[data-hm-quiz-body]'); if (!body) return;
    var step = 0, ans = {};
    function fitsPlayers(c) { return c.min <= ans.players[1] && c.max >= ans.players[0]; }
    function fitsGame(c) { return ans.game === 'any' || has(c.games, ans.game); }
    function moodHit(c) { for (var i = 0; i < ans.mood.length; i++) if (has(c.cats, ans.mood[i])) return ans.mood[i]; return null; }
    function results() {
      var scored = cards.map(function (c) {
        var p = fitsPlayers(c), g = fitsGame(c), m = moodHit(c);
        return { c: c, p: p, g: g, m: m, score: (g ? 4 : 0) + (p ? 3 : 0) + (m ? 2 : 0) };
      }).filter(function (x) { return x.g && (x.p || x.m); });
      scored.sort(function (a, b) { return b.score - a.score || a.c.name.localeCompare(b.c.name); });
      return scored.slice(0, 3);
    }
    function draw() {
      clear(body);
      var dots = el('div', 'hm-steps-dots'); for (var i = 0; i < QS.length; i++) { var d = el('i'); if (i < step) d.className = 'is-done'; dots.appendChild(d); }
      body.appendChild(dots);
      if (step < QS.length) {
        var Q = QS[step]; body.appendChild(el('p', 'hm-q', Q.q));
        var opts = el('div', 'hm-opts');
        Q.opts.forEach(function (o) {
          var b = el('button', 'hm-opt', o.t); b.type = 'button'; if (o.s) b.appendChild(el('small', null, o.s));
          b.addEventListener('click', function () { ans[Q.key] = o.v; step++; draw(); });
          opts.appendChild(b);
        });
        body.appendChild(opts);
        if (step > 0) { var back = el('button', 'hm-btn', 'Back'); back.type = 'button'; back.addEventListener('click', function () { step--; draw(); }); var row = el('div', 'hm-actions'); row.style.justifyContent = 'flex-start'; row.appendChild(back); body.appendChild(row); }
        return;
      }
      var r = results();
      body.appendChild(el('p', 'hm-q', r.length ? 'Start with ' + (r.length === 1 ? 'this one.' : 'these.') : 'Nothing fits all three yet.'));
      if (r.length) {
        var picks = el('div', 'hm-picks');
        r.forEach(function (x) {
          var a = el('a', 'hm-pick hm-link'); a.href = x.c.href;
          var why = []; if (x.p) why.push('fits your group'); if (x.m) why.push(MOOD_WHY[x.m]);
          a.appendChild(el('em', null, why.join(' · ')));
          a.appendChild(el('b', null, x.c.name)); a.appendChild(el('span', null, x.c.summary));
          picks.appendChild(a);
        });
        body.appendChild(picks);
      } else body.appendChild(el('p', 'hm-sub', 'Try a different mood, or browse every mode below.'));
      var again = el('button', 'hm-btn', 'Start over'); again.type = 'button'; again.addEventListener('click', function () { step = 0; ans = {}; draw(); });
      var row2 = el('div', 'hm-actions'); row2.style.justifyContent = 'flex-start'; row2.appendChild(again);
      if (ans.game === 'any') { var shop = el('a', 'hm-btn hm-btn--go hm-link', 'Which HOOKS! is which'); shop.href = '/pages/comparison'; row2.appendChild(shop); }
      body.appendChild(row2);
    }
    draw();
  }

  function init() { readCards(); initFilters(); initQuiz(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
